<div class="dialog-container">
  <h2>{{ data.title }}</h2>

  @if (data.logoUrl) {
    <img [src]="data.logoUrl" alt="Logo" class="dialog-logo" />
  }

  <div class="dialog-message-container">
    @for (message of data.messages; track message) {
      <div class="dialog-message">
        {{ message }}
      </div>
    }
  </div>

  <div class="dialog-actions">
    <button mat-button color="primary" (click)="onPrimaryClick()">
      {{ data.primaryButtonText }}
    </button>

    @if (data.secondaryButtonText) {
      <button mat-button class="secondary-button" (click)="onSecondaryClick()">
        {{ data.secondaryButtonText }}
      </button>
    }
  </div>
</div>